import React, { Fragment } from 'react';

import Instrument from 'src/components/instrument/Instrument';

import {
    Box,
    Grid,
    colors
} from '@material-ui/core';

const DWMM10 = ({ usageItem, sendCommands }) => {

    return (

        <Fragment>

            <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="stretch">

                <Grid
                    item
                    lg={2}
                    md={12}
                    xs="auto">

                    <Instrument
                        panel={usageItem.panel}
                        instrument={usageItem.panel.instruments[5]}
                        message={usageItem.message}
                        event={usageItem.event}
                        device={usageItem.device}
                        schedules={usageItem.schedules}
                        commands={usageItem.commands}
                        sendCommands={sendCommands}
                        alarm={usageItem.alarm}
                    />

                </Grid>

                <Grid
                    item
                    lg={8}
                    md={12}
                    xs="auto" >

                    <Instrument
                        panel={usageItem.panel}
                        instrument={usageItem.panel.instruments[6]}
                        message={usageItem.message}
                        event={usageItem.event}
                        device={usageItem.device}
                        schedules={usageItem.schedules}
                        commands={usageItem.commands}
                        sendCommands={sendCommands}
                        alarm={usageItem.alarm}
                    />

                </Grid>

                <Grid
                    item
                    lg={2}
                    md={12}
                    xs="auto" >
                    <Instrument
                        panel={usageItem.panel}
                        instrument={usageItem.panel.instruments[7]}
                        message={usageItem.message}
                        event={usageItem.event}
                        device={usageItem.device}
                        schedules={usageItem.schedules}
                        commands={usageItem.commands}
                        sendCommands={sendCommands}
                        alarm={usageItem.alarm}
                    />
                </Grid>

            </Grid>


            <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="stretch">

                <Grid
                    item
                    lg={2}
                    md={12}
                    xs="auto">

                    <Instrument
                        panel={usageItem.panel}
                        instrument={usageItem.panel.instruments[1]}
                        message={usageItem.message}
                        event={usageItem.event}
                        device={usageItem.device}
                        schedules={usageItem.schedules}
                        commands={usageItem.commands}
                        sendCommands={sendCommands}
                        alarm={usageItem.alarm}
                    />

                </Grid>

                <Grid
                    item
                    lg={8}
                    md={12}
                    xs="auto" >

                    <Instrument
                        panel={usageItem.panel}
                        instrument={usageItem.panel.instruments[3]}
                        message={usageItem.message}
                        event={usageItem.event}
                        device={usageItem.device}
                        schedules={usageItem.schedules}
                        commands={usageItem.commands}
                        sendCommands={sendCommands}
                        alarm={usageItem.alarm}
                    />

                </Grid>


            </Grid>

            <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="stretch">

                <Grid
                    item
                    lg={12}
                    md={12}
                    xs="auto" >

                    <Box padding={1} margin={1} border={1} borderRadius={4}
                        borderColor={colors.grey[300]}>

                        <Grid
                            container
                            direction="row"
                            justify="flex-start"
                            alignItems="stretch">

                            <Grid
                                item
                                lg={3}
                                xs={3}>

                                <Instrument
                                    panel={usageItem.panel}
                                    instrument={usageItem.panel.instruments[2]}
                                    message={usageItem.message}
                                    event={usageItem.event}
                                    device={usageItem.device}
                                    schedules={usageItem.schedules}
                                    commands={usageItem.commands}
                                    sendCommands={sendCommands}
                                    alarm={usageItem.alarm}
                                />

                            </Grid>


                            <Grid
                                item
                                lg={6}
                                xs={6} >
                                <Instrument
                                    panel={usageItem.panel}
                                    instrument={usageItem.panel.instruments[4]}
                                    message={usageItem.message}
                                    event={usageItem.event}
                                    device={usageItem.device}
                                    schedules={usageItem.schedules}
                                    commands={usageItem.commands}
                                    sendCommands={sendCommands}
                                    alarm={usageItem.alarm}
                                />
                            </Grid>

                        </Grid>

                    </Box>

                </Grid>

            </Grid>

        </Fragment >
    );

}

export default DWMM10;